<template lang="pug">
.send-document-report-table-component
  .title 文書送付

  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // ヘッダー：送付日時
    template(#head(sendDatetime)="row")
      span 送付日時
    // ヘッダー：文書タイトル
    template(#head(title)="row")
      span 文書タイトル
    // ヘッダー：利用者グループ
    template(#head(residentGroup)="row")
      span 利用者グループ
    // ヘッダー：利用者
    template(#head(resident)="row")
      span 利用者
    // ヘッダー：家族
    template(#head(family)="row")
      span 家族
    // ヘッダー：オプション
    template(#head(option)="row")
      span オプション
    // ヘッダー：返信状態
    template(#head(status)="row")
      span 返信状態
    // ヘッダー：同意／確認の返信日時
    template(#head(replyDatetime)="row")
      span 同意／確認の返信日時
    // ヘッダー：返信時の連絡事項
    template(#head(message)="row")
      span 返信時の連絡事項

    // セル：送付日時
    template(#cell(sendDatetime)="row")
      span {{ convertSendDatetimeText(row.item.sendDatetime) }}
    // セル：利用者グループ
    template(#cell(residentGroup)="row")
      span {{ row.item.residentInfo.groupName }}
    // セル：利用者
    template(#cell(resident)="row")
      span {{ row.item.residentInfo.name }}（{{ row.item.residentInfo.room }}）
    // ヘッダー：オプション
    template(#cell(option)="row")
      span {{ convertOptionLabel(row.item) }}
    // セル：家族
    template(#cell(family)="row")
      span {{ row.item.residentInfo.familyName }}（{{ row.item.residentInfo.familyRelation }}）
    // セル：返信状態
    template(#cell(status)="row")
      span {{ convertStatusText(row.item) }}
    // セル：同意／確認の返信日時
    template(#cell(replyDatetime)="row")
      span {{ convertSendDatetimeText(row.item.datetime) }}
    // セル：返信時の連絡事項
    template(#cell(message)="row")
      span {{ row.item.message }}
</template>

<script lang="ts">
import { SendDocumentReplyGetModel } from "@/commons/services/SendDocuments";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 活動履歴(文書送付)テーブルコンポーネント
 */
@Component({})
export default class SendDocumentsReportPreviewTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SendDocumentsReportPreviewTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SendDocumentsReportPreviewTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<SendDocumentsReportPreviewTableItem> {
    return this.value;
  }

  public convertSendDatetimeText(datetime: number | null): string {
    if (datetime == null) {
      return "－";
    }

    const date: string = this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
    return date;
  }

  public convertOptionLabel(item: SendDocumentsReportPreviewTableItem): string {
    if (item.needAgreement == true) {
      return "同意取得";
    } else if (item.needConfirm == true) {
      return "確認取得";
    } else {
      return "－";
    }
  }

  public convertStatusText(item: SendDocumentsReportPreviewTableItem): string {
    if (item.datetime == null) {
      return "－";
    }

    if (item.needAgreement == true) {
      return "同意";
    } else if (item.needConfirm == true) {
      return "確認";
    } else {
      return "－";
    }
  }
}

/** テーブルの列名の情報 */
export interface SendDocumentsReportPreviewTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SendDocumentsReportPreviewTableItem extends SendDocumentReplyGetModel {
  /** 返信日時 継承元がnumberだがnullを許容したいのでanyとする */
  datetime: any;
  /** 送付日時 */
  sendDatetime: number;
  /** タイトル */
  title: string;
  /** 確認しましたボタンを付与するか */
  needConfirm: boolean;
  /** 同意しましたボタンを付与するか */
  needAgreement: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.send-document-report-table-component {
  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 4px;
  }
}
</style>
